import { render, staticRenderFns } from "./a35.vue?vue&type=template&id=98a7e2ba&scoped=true&"
import script from "./a35.vue?vue&type=script&lang=js&"
export * from "./a35.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a7e2ba",
  null
  
)

export default component.exports